import { PayloadAction } from '@reduxjs/toolkit';
import { IPlacementRequirementKey } from 'app/models/Placement/PlacementDetails';
import InitPlacementSummary, { IConsolidatedRequirementResponse } from '../init.types';
import { IPlacementSummaryRequest } from '../slice';
import {
  processPlacementStatusRequirements,
  requestPlacementStatusRequirements,
  type IPlacementStatusRequirementHelperConfig,
} from './statusRequirementHelper';

const roleBasedAccessStatusRequirementConfig: IPlacementStatusRequirementHelperConfig = {
  consolidatedField: 'roleBasedAccessStatusDetails',
  requirementKey: 'amnRequirement',
  messageTypeId: IPlacementRequirementKey.roleBasedAccessOnAssignment,
  getMessageId: () => 2049,
  requestError: {
    functionName: 'requestRoleBasedAccessStatusRequirements',
    area: 'src/store/redux-store/placement-summary/common-saga/roleBasedAccessStatusRequirement.ts',
  },
  processError: {
    functionName: 'processRoleBasedAccessStatusRequirements',
    area: 'src/store/redux-store/placement-summary/common-saga/roleBasedAccessStatusRequirement.ts',
  },
};

export function* requestRoleBasedAccessStatusRequirements(action: PayloadAction<IPlacementSummaryRequest>) {
  yield* requestPlacementStatusRequirements(roleBasedAccessStatusRequirementConfig);
}

export function* processRoleBasedAccessStatusRequirements(
  response: IConsolidatedRequirementResponse<unknown>,
  _context: InitPlacementSummary,
) {
  yield* processPlacementStatusRequirements(response, roleBasedAccessStatusRequirementConfig);
}
